const TopHeader = ({setScreen}) => (
	<div className="d-flex flew-row align-items-center justify-content-center topHeader">
		<div className="headerTitle p-4" onClick={() => setScreen("Welcome")}>
			Casa y Condo
		</div>
	</div>
)

export default TopHeader